module.exports = __webpack_public_path__ + "img/d144d29c9ef395690251de771051f1a1.e6e9c34a.jpg";